import React from 'react';
import Card from './Card.js';

const CardList = ({ robots }) => {
  return (
    <fragment>
        {
        robots.map((user, i) => {
          return (
            <Card
            key={i}
            id={robots[i].id}
            name={robots[i].name}
            username={robots[i].username}
            />
          )
          })
        }
      </fragment>
  );
}

export default CardList;
